module.exports = __webpack_public_path__ + "static/media/SL 28.ea62f569.mp3";